import React from 'react';
import { hot } from 'react-hot-loader/root';
import { BrowserRouter } from 'react-router-dom';
import styled from 'styled-components';
import Router from './Router';
import { UserPolicyProvider } from './user-policy';

const NotProductionWarning = styled.div`
  background-color: rgba(245, 95, 68, 0.9);
  color: #ffffff;
  font-weight: bold;
  position: absolute;
  width: 100%;
  height: 24px;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

function App() {
  // Reason for being in App and not in Router:
  //   https://github.com/remix-run/react-router/issues/7015#issuecomment-548420654
  //
  //   > You can't use any of the hooks from within the same component
  //   > that puts the Router into the tree.
  //   > You need to move your BrowserRouter out of that component.
  //   > It can go in the ReactDOM.render() call, for instance.
  const notProductionWarning = process.env.REACT_APP_ENVIRONMENT_DESCRIPTION;
  return (
    <BrowserRouter>
      {notProductionWarning && <NotProductionWarning>{notProductionWarning}</NotProductionWarning>}

      <UserPolicyProvider>
        <Router />
      </UserPolicyProvider>
    </BrowserRouter>
  );
}

export default process.env.NODE_ENV === 'development' ? hot(App) : App;
